import {create} from 'zustand';

type StatusBarColorStore = {
  color: string;
  isDimmed: boolean;
  setColor: (color: string) => void;
  setDimmed: (isDimmed: boolean) => void;
};

export const useStatusBarColorStore = create<StatusBarColorStore>()((set) => ({
  color: '',
  isDimmed: false,
  setColor: (color: string) => set({color}),
  setDimmed: (isDimmed: boolean) => set({isDimmed})
}));
